import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Bill, Transaction } from "model";
/**
* @class PaymentTransaction
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.paymentTransaction[0];
* const payment = new PaymentTransaction(record);
* @property {NUMBER} _mapID - The id of the payment related transaction data
* @property {NUMBER} _number - the number on the payment
* @property {STRING} _memo - memo on payment
* @property {NUMBER} _billID - The id of the bill related
*/
export default class PaymentTransaction extends BCMSRecord{
    _mapID;   
    _number;  
    _memo;   
    _billID;

    constructor (record){   
      if(record.mapID) {
        super(Object.assign(record,Transaction.initByID(record.mapID).record));
      } else {
        super(Object.assign(record, Transaction.init(record).record));
      }
    }    
  } 
  PaymentTransaction.define({
    "recordType":"paymentTransactions",
    "recordIDProp":"mapID",
    "className" : "PaymentTransaction",
    "recordProperties":[
      /** 
      * @name mapID
      * @instance
      * @property get {NUMBER} - gets the mapID of the payment
      * @property set {NUMBER} - sets the imapIDd of the payment
      * @memberof PaymentTransaction 
      */
      BCMSRecordProperty.mapToNumber("mapID","_mapID"),
      /** 
      * @name number
      * @instance
      * @property get {NUMBER} - gets the number of the payment
      * @property set {NUMBER} - sets the number of the payment
      * @memberof PaymentTransaction 
      */
      BCMSRecordProperty.mapToNumber("number","_number"),
      /** 
      * @name memo
      * @instance
      * @property get {STRING} - gets the memo of the payment
      * @property set {STRING} - sets the memo of the payment
      * @memberof PaymentTransaction 
      */
      BCMSRecordProperty.mapToString("memo","_memo"),

      /**
       * @name billID
       * @instance
       * @property get {NUMBER} - gets the billID of the payment
       * @property set {NUMBER} - sets the billID of the payment
       * @memberof PaymentTransaction
       */
      BCMSRecordProperty.mapToClass("billID", "_billID", () => Bill)
    ].concat(Transaction._RecordProperties)
})




